/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".box-uat[_ngcontent-%COMP%]{border-radius:7px;background-color:#fff;box-shadow:0 0 10px 0 rgba(0,0,0,.2);color:#373737;display:block;position:relative;margin:5px}\n/*# sourceMappingURL=cards-uat-live.component.css.map*/"];
export { styles as styles };
